import {ref, watch, computed} from "vue";
import {useRoute} from "vue-router";
import {PATH_HANDLER} from "@/config";
import { useStore } from "vuex";


export default function(step){
  const url = PATH_HANDLER.path+"/images/"
  const route = useRoute()
  const gender = ref(route.query.gender)
  const step5Data = ref()
  const step5Check = ref(false)
  const step5Check2 = ref(false)
  const step2Check = ref(false)

  const store = useStore()
  const results = computed(() => {
    return store.state.moduleA.results;
  })

  step5Watcher()
  step2Watcher()

  watch(() => results.value, (val) => {
    step5Watcher()
    step2Watcher()
  })

  function step2Watcher(){
    if (results.value.length > 1){
      const step2Val = results.value.find(item => {
        return item.step === 2
      }).val

      const targetshape = ["softFlat"];
      step2Check.value = targetshape.includes(step2Val)
    }
  }
  function step5Watcher(){
    if (results.value.length > 4){
      const step5Val = results.value.find(item => {
        return item.step === 5
      }).val
      step5Data.value = step5Val

      const targetWidth = ["2.8mm" , "3.0mm" , "3.2mm" , "3.4mm" , "3.6mm" , "3.8mm"];
      step5Check.value = !targetWidth.includes(step5Val)

      const targetWidth2 = ["2.4mm" , "2.6mm"];
      step5Check2.value = !targetWidth2.includes(step5Val)
    }
  }

  const currentImage = (data, option=null) => {
    if (step === "step1"){
      if (data){
        return url+step+"/"+gender.value+"/"+data.val+".jpg"
      } else {
        return url+step+"/"+gender.value+"/PT.jpg"
      }
    } else if (step === "step2"){
      if (data){
        return url+step+"/"+gender.value+"/"+data.val+".jpg"
      } else {
        return url+step+"/"+gender.value+"/round.jpg"
      }
    } else if (step === "step3"){
      return url+step+"/"+data.val+".jpg"

    } else if (step === "step4"){
      return url+"common/ring/round/2.6/simple_"+data.val+"_2.6.jpg"

    } else if (step === "step5"){
      if (data){
        return url+step+"/"+gender.value+"/"+data.val+".jpg"
      } else {
        return url+step+"/"+gender.value+"/2.6mm.jpg"
      }
    } else if (step === "step6"){
      return url+"common/ring/round/2.6/simple_matte_2.6"+data.val+".jpg"

    } else if (step === "step7"){
      // for hineridome
      if(data.val === "hineridome"){
        if(step5Check2 && step2Check) {
          const arrangedData = data.val.split("_")[0]
          let imageObj = {
            ring: url+"common/ring/round/2.2/simple_matte_2.2.jpg",
            base: url+"common/ring/option/"+arrangedData+"5Base_small.png",
            diamond: url+"common/ring/option/"+arrangedData+"5BaseDia_small.png",
            forDialogue: url+step+"/"+data.val+"5Base.jpg",
          }
          return imageObj
        }else{
          const arrangedData = data.val.split("_")[0]
          let imageObj = {
            ring: url+"common/ring/round/2.2/simple_matte_2.2.jpg",
            base: url+"common/ring/option/"+arrangedData+"7Base_large.png",
            diamond: url+"common/ring/option/"+arrangedData+"7BaseDia_large.png",
            forDialogue: url+step+"/"+data.val+"7Base.jpg",
          }
          return imageObj
        }
      }
      // for others
      else {
        if (step5Check){
          const arrangedData = data.val.split("_")[0]
          let imageObj = {
            ring: url+"common/ring/round/2.6/simple_matte_2.6.jpg",
            base: url+"common/ring/option/"+arrangedData+"_small.png",
            diamond: url+"common/ring/option/"+arrangedData+"Dia_small.png",
            forDialogue: url+step+"/"+data.val+".jpg",
          }
          if (option && option!=='transparent'){
            imageObj.color = url+"common/ring/option/"+arrangedData+"/"+option+".png"
          }
          return imageObj  
        } else {
          const arrangedData = data.val.split("_")[0]
          let imageObj = {
            ring: url+"common/ring/round/2.6/simple_matte_2.6.jpg",
            base: url+"common/ring/option/"+arrangedData+"_large.png",
            diamond: url+"common/ring/option/"+arrangedData+"Dia_large.png",
            forDialogue: url+step+"/"+data.val+".jpg",
          }
          if (option && option!=='transparent'){
            imageObj.color = url+"common/ring/option/"+arrangedData+"/"+option+".png"
          }
          return imageObj  
        }
      }
    }else if (step === "step9"){
      if(data.val.includes("_")){
        return url+step+"/"+data.val.split("_")[0]+".jpg"
      }else{
        return url+step+"/"+data.val+".jpg"
      }
    } else {
      return ""
    }
  }
  return {currentImage, step5Data, step5Check, step5Check2, step2Check}
}
